/**
 * Component for validating that a user is authenticated and has the desired roles
 * and/or permissions for the organization before permitting a user to visit a route
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import ErrorPageContainer from '../ErrorPage/ErrorPageContainer';
import LoginRedirect from '../LoginPage/LoginRedirect/LoginRedirect';

const propTypes = {
  userPerms: PropTypes.arrayOf(PropTypes.string),
  userRoles: PropTypes.arrayOf(PropTypes.string),
  perms: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(PropTypes.string),
  isAuthenticated: PropTypes.func.isRequired,
  render: PropTypes.func,
};

const defaultProps = {
  userPerms: null,
  userRoles: null,
  perms: null,
  roles: null,
  render: null,
};

function AuthorizedRoute({ userPerms, userRoles, perms, roles, isAuthenticated, render, ...rest }) {
  let props = rest;
  if (!isAuthenticated()) {
    props = { ...props, component: LoginRedirect };
    return <Route {...props} />;
  }
  const hasPerm = !perms || (userPerms && perms.some((val) => userPerms.includes(val)));
  const hasRole = !roles || (userRoles && roles.some((val) => userRoles.includes(val)));
  if (!hasPerm || !hasRole) {
    props = { ...props, component: ErrorPageContainer };
    return <Route {...props} />;
  }
  return <Route render={render} {...rest} />;
}

AuthorizedRoute.propTypes = propTypes;
AuthorizedRoute.defaultProps = defaultProps;

export default AuthorizedRoute;
